module.exports = __webpack_public_path__ + "static/media/ExtendedWarranty.5d772675.svg";